import React from "react";
import { TemplateView } from "@rankmi/ats-app";

function Templates({ organizationId, currentUser }) {
  const access = currentUser.is_admin || currentUser.role_id === 1;
  if (!access) window.location.replace("/");

  return (
    <div>
      {access && (
        <TemplateView organizationId={organizationId} />
      )}
    </div>
  );
}

export default Templates;
